import { create } from 'zustand';

export interface ICustomStore {
    menuOpen: boolean
    toggleMenuOpen: () => void
    closeMenu: () => void
    openMenu: () => void
    genresMenuOpen?: boolean
    toggleGenresMenuOpen?: () => void
    closeGenresMenu?: () => void
}

export const useCustomStore = create<ICustomStore>((set) => ({
    menuOpen: false,
    genresMenuOpen: false,
    toggleMenuOpen: () => set((state) => ({ menuOpen: !state.menuOpen })),
    closeMenu: () => set({ menuOpen: false }),
    openMenu: () => set({ menuOpen: true }),
    toggleGenresMenuOpen: () => set((state) => ({ genresMenuOpen: !state.genresMenuOpen })),
    closeGenresMenu: () => set({ genresMenuOpen: false  })
}));
